module.exports = "<div class=\"title\">Send personal daily report</div>\r\n\r\n<i class=\"fa fa-spinner fa-spin\" *ngIf=\"processing\"></i>\r\n<a (click)=\"sendReport()\" class=\"btn btn-blue\">Report Daily Time</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-time/personal-daily-report/personal-daily-report.component.html
// module id = 504
// module chunks = 0